import styles from "../styles.module.css";

type Props = {
  title: string;
  step?: number;
  min?: number;
  max?: number;
  value?: any;
  customValidity?: string;
  setter?: React.Dispatch<React.SetStateAction<number>>;
  showAsterisk?: boolean;
};

const CampoNumber = ({
  title,
  step,
  min,
  max,
  value,
  customValidity,
  setter,
  showAsterisk,
}: Props) => {
  const nome = title.toLowerCase().replace(" ", "_");

  return (
    <div className={styles.campo}>
      <label htmlFor={nome}>
        {title}
        <span className={styles.required}>{showAsterisk && "*"}</span>:
      </label>

      <input
        type="number"
        name={nome}
        step={step}
        min={min}
        max={max}
        value={value}
        onInvalid={(e) => {
          if (customValidity) {
            e.currentTarget.setCustomValidity(customValidity);
          }
        }}
        onChange={(e) => {
          if (setter) {
            const v = e.target.value;
            setter(Number(v));
            e.currentTarget.setCustomValidity("");
          }
        }}
      />
    </div>
  );
};

export default CampoNumber;
